import {
  Group,
  IPaginatedResponse,
} from '@jupiterone/jupiter-web-toolkit/src/types';
import urls from '@jupiterone/jupiter-web-toolkit/src/urls';
import retryIfTimeout from '@jupiterone/jupiter-web-toolkit/src/util/retryIfTimeout';
import useJ1AuthFetch from '@jupiterone/jupiter-web-toolkit/src/api/fetch/useJ1AuthFetch';

const GROUP_NUMBER_TO_FETCH = 20;

const useGroupClient = () => {
  const { authFetch } = useJ1AuthFetch();
  function normalizeGroup(group: Group): Group {
    return {
      ...group,
      name: group.name.trim(),
    };
  }

  async function getGroups(
    linksNext?: string,
    pageSize = GROUP_NUMBER_TO_FETCH
  ): Promise<IPaginatedResponse> {
    const fetchPath = linksNext
      ? `/api${linksNext}`
      : `${urls.groups}?pageSize=${pageSize}`;

    return retryIfTimeout(() => {
      return authFetch(fetchPath, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
    });
  }

  async function updateGroup(body: Group): Promise<Group> {
    delete body.deleteProtected;
    return retryIfTimeout(() => {
      return authFetch(`${urls.groups}/${body.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(normalizeGroup(body)),
      });
    });
  }

  async function createGroup(): Promise<Group> {
    const body = {
      name: ' ',
    };
    return retryIfTimeout(() => {
      return authFetch(`${urls.groups}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
    });
  }

  async function deleteGroup(groupID: string): Promise<Response> {
    return authFetch(`${urls.groups}/${groupID}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  async function getGroup(id: string): Promise<Group> {
    return retryIfTimeout(() => {
      return authFetch(`${urls.groups}/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
    });
  }

  async function getGroupMembers(
    id: string,
    loadMoreLink?: string
  ): Promise<IPaginatedResponse> {
    return retryIfTimeout(() => {
      return authFetch(
        loadMoreLink ? `/api${loadMoreLink}` : `${urls.groups}/${id}/members`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
    });
  }

  async function deleteGroupMember(
    memberId: string,
    groupId: string
  ): Promise<any> {
    return authFetch(`${urls.groups}/${groupId}/members/${memberId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
  return {
    normalizeGroup,
    getGroups,
    updateGroup,
    createGroup,
    deleteGroup,
    getGroup,
    getGroupMembers,
    deleteGroupMember,
  };
};

export default useGroupClient;
